/* global MutationObserver */
// JavaScript function to handle onload events and register functions
document.addEventListener("DOMContentLoaded", function () {
  initAnimationToggle();
});

//Animation toggle
function initAnimationToggle() {
  document.querySelectorAll('.wp-block-accordion').forEach((accordion) => {
    const items = accordion.querySelectorAll('.wp-block-accordion-item');
    if (!items.length) return;

    items.forEach((item) => {
      const panel = item.querySelector('.wp-block-accordion-panel');
      if (!panel) return;

      // Prevent double-initialization
      if (panel.dataset.animBound === 'true') return;
      panel.dataset.animBound = 'true';

      // Prepare panel
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height 0.4s ease';

      const observer = new MutationObserver(() => {
        if (item.classList.contains('is-open')) {
          // OPEN
          panel.style.height = 'auto';             // set to auto to measure natural height
          const height = panel.scrollHeight + 'px';
          panel.style.height = '0px';              // reset to 0 for animation start

          requestAnimationFrame(() => {
            panel.style.height = height;           // animate to measured height
          });

          panel.addEventListener(
            'transitionend',
            () => {
              // lock to auto after animation for flexible content
              panel.style.height = 'auto';
            },
            { once: true }
          );
        } else {
          // CLOSE
          // set current height to enable smooth collapse
          panel.style.height = panel.scrollHeight + 'px';

          requestAnimationFrame(() => {
            panel.style.height = '0px';
          });
        }
      });

      // Observe only class changes on the item
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });

      // Store observer so we can disconnect later if needed
      item._accordionHeightObserver = observer;

      // Optional: initialize correct height on load based on current state
      if (item.classList.contains('is-open')) {
        panel.style.height = 'auto';
      } else {
        panel.style.height = '0px';
      }
    });
  });
}


function initTabsAccordions() {
  const accordions = document.querySelectorAll(
    '.wp-block-accordion.tabs-v1, \
     .wp-block-accordion.tabs-v2, \
     .wp-block-accordion.tabs-v3, \
     .wp-block-accordion.tabs-v4, \
     .wp-block-accordion.tabs-v5, \
     .wp-block-accordion.tabs-v6, \
     .wp-block-accordion.tabs-v7'
  );

  if (!accordions.length) return;

  accordions.forEach((accordion) => {

    /* =========================================
       1) Open first item by default
    ========================================= */
    const items = accordion.querySelectorAll('.wp-block-accordion-item');
    if (!items.length) return;

    const firstItem = items[0];
    const context = firstItem.getAttribute('data-wp-context');

    if (context) {
      try {
        const parsed = JSON.parse(context);
        parsed.openByDefault = true;
        firstItem.setAttribute('data-wp-context', JSON.stringify(parsed));
      } catch {
        firstItem.classList.add('is-open');
      }
    } else {
      firstItem.classList.add('is-open');
    }

    /* =========================================
       2) Single-open behavior (tabs logic)
    ========================================= */
    accordion.addEventListener(
      'click',
      (e) => {
        const toggleBtn = e.target.closest('.wp-block-accordion-heading__toggle');
        if (!toggleBtn) return;

        const currentItem = toggleBtn.closest('.wp-block-accordion-item');
        if (!currentItem) return;

        // If clicking already open tab → do nothing
        if (currentItem.classList.contains('is-open')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        // Close all other open tabs
        accordion
          .querySelectorAll('.wp-block-accordion-item.is-open')
          .forEach((item) => {
            if (item !== currentItem) {
              item.classList.remove('is-open');

              const panel = item.querySelector('.wp-block-accordion-panel');
              if (panel) {
                panel.style.height = '0px';
                panel.style.overflow = 'hidden';
              }
            }
          });
      },
      true // capture phase is REQUIRED
    );
  });
}

/* Init */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabsAccordions);
} else {
  initTabsAccordions();
}

